(function(){
    'use strict';

    var $smpCTAForm = $('.smp-cta-bar .sq-form-field');

        if($smpCTAForm.length){

            $smpCTAForm.on('focusin', function(){
                $(this).parent().parent().addClass('active');
            });

            $smpCTAForm.on('focusout', function(){
                if (!$(this).val().length) {
                    $(this).parent().parent().removeClass('active');
                }
            });
        }
}());